import { Navigate, Route, Routes } from 'react-router-dom';
import {
  ACCOUNT_PATH,
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  LOGIN_PATH,
  ORDERS_PATH,
  REPORTS_PATH,
  RESET_PASSWORD_PATH,
  SHOPIFY_ORDERS_PATH
} from '~/constants';
import useTrackingProviders from '~/hooks/useTrackingProviders';
import { Providers } from '~/providers/Providers';
import { ForgotPassword, Login, NotFound, Orders, Reports, ResetPassword, ShopifyOrders } from '~/routes';
import { AuthenticatedLayout } from './components/organisms/AuthenticatedLayout';
import { UnauthenticatedLayout } from './components/organisms/UnauthenticatedLayout';
import { AuthRedirect } from './components/utilities/AuthRedirect';
import { RequireAuth } from './components/utilities/RequireAuth';

function App() {
  useTrackingProviders();

  return (
    <Providers>
      <Routes>
        {/* Authenticated Routes */}
        <Route element={<RequireAuth />}>
          <Route element={<AuthenticatedLayout />}>
            <Route path={HOME_PATH} element={<Navigate to={ORDERS_PATH} replace />} />
            <Route path={ORDERS_PATH} element={<Orders />} />
            <Route path={SHOPIFY_ORDERS_PATH} element={<ShopifyOrders />} />
            <Route path={REPORTS_PATH} element={<Reports />} />
          </Route>
        </Route>

        {/* Unauthenticated Routes */}
        <Route element={<AuthRedirect />}>
          <Route element={<UnauthenticatedLayout />}>
            <Route path={ACCOUNT_PATH}>
              <Route path={LOGIN_PATH} element={<Login />} />
              <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPassword />} />
              <Route path={RESET_PASSWORD_PATH} element={<ResetPassword />} />
            </Route>
          </Route>
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Providers>
  );
}

export default App;
